<!-- Copyright 2023 (Unpublished) Verto Inc. -->

<section class="pack-details">
  <div class="pack-fields">
    <mat-form-field appearance="fill">
      <mat-label>Branch Name</mat-label>
      <input name="packName" matInput [(ngModel)]="branchName" (input)="clearPackNames()" />
    </mat-form-field>
    <mat-form-field appearance="fill" (click)="getPackNames()">
      <mat-label>Pack Name</mat-label>
      <input matInput name="packName" [(ngModel)]="packName" [matAutocomplete]="autoPack" (input)="onPackNameInput()" />
      <mat-autocomplete (optionSelected)="onPackNameSelected()" autoActiveFirstOption #autoPack="matAutocomplete">
        <mat-option *ngFor="let pack of filteredPacks" [value]="pack">
          {{ pack }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="fill" (click)="getClients()">
      <mat-label>Client Name (optional)</mat-label>
      <input
        matInput
        name="clientName"
        [(ngModel)]="clientName"
        [matAutocomplete]="autoClient"
        [disabled]="packName === ''"
        (input)="onClientNameInput()"
        (click)="onClientNameInput()"
      />
      <mat-autocomplete autoActiveFirstOption #autoClient="matAutocomplete">
        <mat-option *ngFor="let client of filteredClientNames" [value]="client">
          {{ client }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <button mat-raised-button (click)="getNewWorkflows()">View Pack</button>
</section>

<section class="loading-container" *ngIf="loadingWorkflows">
  <img src="assets/images/loading.gif" alt="loading" />
  <h3>Loading workflows...</h3>
</section>

<section class="workflows" *ngIf="workflowsToLoad.length > 0">
  <div class="resize-container">
    <div class="resize-parent">
      <div class="resize-content">
        <div class="side-menu">
          <section class="side-menu-buttons">
            <a mat-raised-button (click)="scrollToTop()">Scroll to top</a>

            <section class="toggle-options">
              <mat-button-toggle-group vertical [(ngModel)]="diffStyle">
                <mat-button-toggle value="diffOnly">Diff Only</mat-button-toggle>
                <mat-button-toggle value="full">Full</mat-button-toggle>
              </mat-button-toggle-group>

              <mat-button-toggle-group
                *ngIf="(currentEnvironment | keyvalue).length > 0"
                vertical
                [(ngModel)]="environmentName"
              >
                <mat-button-toggle (click)="updateView()" value="staging">Staging</mat-button-toggle>
                <mat-button-toggle (click)="updateView()" value="production">Production</mat-button-toggle>
              </mat-button-toggle-group>
            </section>
            <section>
              <mat-slide-toggle [(ngModel)]="showNoDifferences"> Show no differences </mat-slide-toggle>
            </section>
            <a
              href="https://github.com/verto-health/app-config/tree/{{ branchName }}/automate/packs/{{ packName }}"
              target="_blank"
              >Open in app-config</a
            >
            <button
              *ngIf="(currentEnvironment | keyvalue).length > 0"
              (click)="loadAll()"
              class="load-all"
              color="accent"
              mat-flat-button
            >
              Load All with {{ environmentName }} env
            </button>
            <button
              *ngIf="(currentEnvironment | keyvalue).length == 0"
              (click)="loadAll()"
              class="load-all"
              color="accent"
              mat-flat-button
            >
              Load All
            </button>
          </section>

          <section class="links">
            <h5>Workflows to load from {{ loadFromLabel }}</h5>
            <ul>
              <ng-container *ngFor="let workflow of workflowsToLoad">
                <li *ngIf="workflow.workflowDiffConflictsOnlyView !== ''; else same_workflow">
                  <a
                    [class.new]="workflow.isNew"
                    [class.old]="!workflow.isNew"
                    (click)="scrollToWorkflow(workflow.newWorkflow.id)"
                    >{{ workflow.newWorkflow.filename }} ({{ workflow.isNew ? 'New' : 'Update Existing' }})</a
                  >
                </li>
                <ng-template #same_workflow>
                  <li>
                    <a class="same" (click)="scrollToWorkflow(workflow.newWorkflow.id)"
                      >{{ workflow.newWorkflow.filename }} (No changes)</a
                    >
                  </li>
                </ng-template>
              </ng-container>
            </ul>
          </section>
        </div>
      </div>
      <div>
        <div class="resize"></div>
      </div>
    </div>
  </div>

  <div class="workflows-container">
    <ng-container *ngFor="let workflow of workflowsToLoad; let index = index">
      <details
        id="{{ workflow.newWorkflow.id }}"
        class="workflow-to-load"
        *ngIf="workflow.workflowDiffConflictsOnlyView !== '' || showNoDifferences"
        open
      >
        <summary>
          {{ workflow.newWorkflow.filename }}
          <button
            mat-flat-button
            (click)="copyToClipboard(workflow.newWorkflow.filename)"
            class="action"
            matTooltip="Copy filename to clipboard"
          >
            <i class="pi pi-copy"></i>
          </button>
        </summary>
        <div>
          <h5>{{ workflow.newWorkflow.name }} ({{ workflow.newWorkflow.id }})</h5>

          <ng-container *ngIf="(currentEnvironment | keyvalue).length > 0">
            <button
              (click)="loadPack(workflow.newWorkflow, currentEnvironment[environmentName])"
              class="load-workflow"
              color="primary"
              mat-flat-button
            >
              Load [{{ workflow.newWorkflow.name }}] workflow with [{{ environmentName }}] env
            </button>
          </ng-container>

          <button
            (click)="loadPack(workflow.newWorkflow)"
            *ngIf="(currentEnvironment | keyvalue).length === 0"
            class="load-workflow"
            color="primary"
            mat-flat-button
          >
            Load [{{ workflow.newWorkflow.name }}] workflow
          </button>

          <a
            target="_blank"
            href="https://github.dev/verto-health/app-config/blob/{{ branchName }}/{{ workflow.newWorkflow.path }}#L1"
          >
            Edit in app-config
          </a>

          <ngx-object-diff *ngIf="diffStyle === 'full'" [obj]="workflow.workflowDiffFullView"></ngx-object-diff>
          <ngx-object-diff
            *ngIf="diffStyle === 'diffOnly'"
            [obj]="workflow.workflowDiffConflictsOnlyView || 'There are no differences.'"
          ></ngx-object-diff>
        </div>
      </details>
    </ng-container>
  </div>
</section>
